import { baseAxios } from "config";

export const updateAttachmentType = async ({ id, data }) => {
  try {
    const res = await baseAxios.put(`/applicants/${id}/updateAttachmentType`, data);
    return res.data;
  } catch (err) {
    console.error(`Error updating attachment type:`, err);
    throw new Error(err.toString());
  }
};
